import { createDefaultScrollPosition, IScrollPosition } from "@/common/store/scrollStore";

const USER_INPUT_EVENTS = ["wheel", "touchstart", "pointerdown", "keydown"] as const;
const USER_INPUT_LISTENER_OPTIONS = { capture: true, passive: true };

export const findScrollPosition = (
  scrolls: Record<string, IScrollPosition>,
  key: string,
  resumeScrollFrom: string | null,
): IScrollPosition => {
  const resumedScroll = resumeScrollFrom === null ? undefined : scrolls[resumeScrollFrom];

  return scrolls[key] ?? resumedScroll ?? createDefaultScrollPosition();
};

export const keepScrollTopUntilUserInput = (element: HTMLElement, top: number, onUserInput: () => void) => {
  const applyScrollTop = () => {
    if (Math.abs(element.scrollTop - top) > 1) {
      element.scrollTo(0, top);
    }
  };

  const contentResizeObserver = new ResizeObserver(applyScrollTop);

  const stop = () => {
    contentResizeObserver.disconnect();
    USER_INPUT_EVENTS.forEach((type) => window.removeEventListener(type, handleUserInput, USER_INPUT_LISTENER_OPTIONS));
  };

  const handleUserInput = () => {
    stop();
    onUserInput();
  };

  Array.from(element.children).forEach((child) => contentResizeObserver.observe(child));
  USER_INPUT_EVENTS.forEach((type) => window.addEventListener(type, handleUserInput, USER_INPUT_LISTENER_OPTIONS));
  applyScrollTop();

  return stop;
};
